import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetFormattedNewsTagUseCase extends UseCase {
  /**
   * @constructor
   */
  constructor({formattedNewsTagValueObjectFactory}) {
    super()
    this._formattedNewsTagValueObjectFactory = formattedNewsTagValueObjectFactory
  }

  execute = ({tag}) => Promise.resolve(this._formattedNewsTagValueObjectFactory({tag}).toJSON())
}
